import React from 'react';
import { useNavigate } from 'react-router-dom';
import { goProduct, memberPath } from '@/config/hosts';

/** Small top-left control to return to the member app from care tools. */
export default function BackToApp({ className = '', testId = 'care-back-to-app' }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`care-back-to-app ${className}`.trim()}
      onClick={() => goProduct(memberPath('/'), navigate)}
      aria-label="Back to app"
      title="Back to app"
      data-testid={testId}
    >
      <svg className="care-back-to-app-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path
          d="M10 3.5 5.5 8 10 12.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="care-back-to-app-label">Back to app</span>
    </button>
  );
}
